
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcMenuButton as ObcMenuButtonElement} from '@oicl/openbridge-webcomponents/dist/components/menu-button/menu-button.js';
 import {ContextMenuOption} from '@oicl/openbridge-webcomponents/dist/components/context-menu-input/context-menu-input.js';
 export type {ContextMenuOption} from '@oicl/openbridge-webcomponents/dist/components/context-menu-input/context-menu-input.js';
 

 
 export const ObcMenuButton = createComponent({
   react: React,
   tagName: 'obc-menu-button',
   elementClass: ObcMenuButtonElement,
   events: {
     
     onChange: 'change' as EventName<CustomEvent<{selectedValues: string[], selectedOptions: Array<ContextMenuOption>}>>,
     onItemClick: 'item-click' as EventName<CustomEvent<{value: string, option: ContextMenuOption}>>,
     onOpen: 'open' as EventName<CustomEvent<void>>,
     onClose: 'close' as EventName<CustomEvent<void>>,
   }
  });
 
 